import { Link } from "react-router";
import ProfileButton from "./ProfileButton";
import { PopulatedPost } from "@api/src/types/post";
import { useRef, useState } from "react";

interface PostCardProps {
  showNumberOfLikes: PopulatedPost["likes"];
  postId: PopulatedPost["id"];
  usersThatLiked: PopulatedPost["usersThatLiked"];
}
// https://tailwindcomponents.com/component/linkedin-post
export default function PostCardUserPopover({ showNumberOfLikes, postId, usersThatLiked }: PostCardProps) {
  const popoverRef = useRef<HTMLDivElement>(null);
  const [isVisible, setIsVisible] = useState(false);

  return (
    <>
      {isVisible && (
        <div
          id={`users-like-popover-${postId}`}
          ref={popoverRef}
          className={[
            "z-50 transition-all  duration-200",
            // !isVisible ? "pointer-events-none invisible opacity-0" : "visible opacity-100",
          ].join(" ")}
          // className="popover pointer-events-none z-50 flex flex-col items-center justify-center border-2 bg-black/20"
        >
          <div
            className="fixed inset-0 flex size-full flex-col items-center justify-center bg-black/70"
            onClick={() => setIsVisible(false)}
          >
            <div className="max-h-full min-w-80 max-w-full overflow-y-auto rounded-lg bg-white p-4">
              <div className="flex flex-col gap-y-4">
                <span className="text-lg font-semibold">Personnes qui ont aimé ce post</span>
                <span className="text-sm text-gray-500">
                  {usersThatLiked?.map((user) => {
                    return (
                      <div key={user.id} className="flex items-center gap-2">
                        <Link prefetch="intent" to={`/profile/${user.plausible_id}`} className="mt-1">
                          <ProfileButton user={user} />
                        </Link>
                        <div className="ml-2">
                          <Link
                            to={`/profile/${user.plausible_id}`}
                            prefetch="intent"
                            className="font-bold text-sky-900 opacity-85"
                          >
                            {user.firstName} {user.lastName}
                            {`\u00A0`}
                          </Link>
                        </div>
                      </div>
                    );
                  })}
                </span>
              </div>
            </div>
          </div>
        </div>
      )}
      <button
        type="button"
        className="ml-1"
        onClick={() => {
          setIsVisible(true);
        }}
      >
        <span className="px-2">{showNumberOfLikes}</span>
      </button>
    </>
  );
}
